export default class AuthUtils {
  /**
    * Check if the token is formed properly and not expired
    * @param {string} token the token
    */
  static isTokenValid(token) {
    try {
      return new Date(JSON.parse(atob(atob(token).split(':')[0])).expiration).getTime() > Date.now();
    } catch {
      return false;
    }
  }

  /**
    * Device fingerprint for the current session. Standalone-auth binds a refresh to
    * the fingerprint used at sign-in, so this must be whatever sign-in recorded —
    * prefer the value carried on the sign-in response over the hardcoded default.
    * @param {Object} authentication the stored authentication data
    */
  static getFingerprint(authentication = {}) {
    return authentication.fingerprint
      || authentication.deviceFingerprint
      || 'nada-fingerprint';
  }
}
